import Header from "../main-header/header";
import Footer from "../about/Footer";
import React from "react";
import "./portfolio.css";


const projects = [
  {
    title: "Rise Again – Music Video",
    description: "Emotional storytelling in motion.",
    image: "images/right-image-black-small1.jpeg",
    video: "",
  },
  {
    title: "Echoes of Time – Trailer",
    description: "Upcoming sci-fi thriller teaser.",
    image: "images/right-image-black-big1.jpeg",
    video: "",
  },
  {
    title: "Last Sunset – Short Film",
    description: "A visual ode to nostalgia.",
    image: "images/left-image-black1.jpeg",
    video: "",
  },
  {
    title: "Rhythm Fest – Live Show",
    description: "Concert highlights and BTS moments.",
    image: "images/left-image1.jpeg",
    video: "",
  },
];

export default function Portfolio() {
  return (
    <div>
      <Header />
      <div className="portfolio-page">
        <header className="hero-section">
          <h1>VMAA Entertainment</h1>
          <p>Music. Motion. Magic.</p>
        </header>

        <section className="project-grid">
          {projects.map((project, index) => (
            <div className="card" key={index}>
              <img src={project.image} alt={project.title} className="card-img" />
              <div className="card-overlay">
                <h2>{project.title}</h2>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </section>

        <section className="cta-section">
          <h2>Let's Collaborate</h2>
          <p>Looking for an unforgettable film or music video? Let's create something iconic together.</p>
          <a href="/contact" className="cta-button">Contact Us</a>
        </section>

        <Footer />
      </div>
    </div>
  );
}